(function () {
  function initTabs(root) {
    const tabs = root.querySelectorAll('[data-cp-tab]');
    const panels = root.querySelectorAll('[data-cp-panel]');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.cpTab;
        tabs.forEach(t => {
          t.classList.toggle('cp-tabs__tab--active', t === tab);
          t.setAttribute('aria-selected', t === tab);
        });
        panels.forEach(p => {
          const active = p.dataset.cpPanel === target;
          p.classList.toggle('cp-tabs__panel--active', active);
          if (active) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        });
      });
    });
  }

  function initViewMore(root) {
    root.querySelectorAll('[data-cp-view-more], [data-cp-view-more-sets]').forEach(btn => {
      btn.addEventListener('click', () => {
        const panel = btn.closest('[data-cp-panel]') || btn.parentElement;
        const cards = panel.querySelectorAll('[data-cp-card]');
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        cards.forEach((card, i) => {
          if (i > 0) card.classList.toggle('cp-card--hidden', expanded);
        });
        btn.setAttribute('aria-expanded', String(!expanded));
      });
    });
  }

  function initAddToCart(root) {
    root.querySelectorAll('[data-cp-add-form]').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        const label = btn.querySelector('.cp-card__button-label');
        const originalLabel = label.textContent;
        btn.disabled = true;
        label.textContent = 'Adding...';

        try {
          const formData = new FormData(form);
          const res = await fetch(form.action, {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'application/json' }
          });

          if (!res.ok) throw new Error('Add to cart failed');

          label.textContent = 'Added ✓';

          // Trigger Prestige's cart refresh (it listens for this event)
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));

          setTimeout(() => {
            label.textContent = originalLabel;
            btn.disabled = false;
          }, 1500);
        } catch (err) {
          console.error(err);
          label.textContent = 'Error — try again';
          setTimeout(() => {
            label.textContent = originalLabel;
            btn.disabled = false;
          }, 2000);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-cp-tabs]').forEach(root => {
      initTabs(root);
      initViewMore(root);
      initAddToCart(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when section is reloaded (theme editor)
  document.addEventListener('shopify:section:load', init);
})();